import { getTomorrowDate } from '../../utils'
import { useEffect } from 'react'
import { useConfig } from '../../providers/config'
import { useLocalStorage } from '../useLocalStorage'
import { LOCALSTORAGE_RECENTLY_VIEWED_PRODUCTS } from '../../constants'

export const useRecentlyViewedProductAdd = ({ id }) => {
	const {
		catalog: {
			products: {
				recentlyViewed: { limit: recentlyViewedLimit },
			},
		},
	} = useConfig()

	const [storageValue, setStorageValue] = useLocalStorage(LOCALSTORAGE_RECENTLY_VIEWED_PRODUCTS, [])

	useEffect(() => {
		if (id) {
			setStorageValue(
				[id, ...storageValue.filter((productId) => productId !== id)].slice(0, recentlyViewedLimit),
				getTomorrowDate()
			)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id, recentlyViewedLimit])

	return {}
}
